export default __webpack_public_path__ + "static/media/main.8cc57463.mp4";